export default __webpack_public_path__ + "static/media/manual-snap.dc735ebd.png";